<template>
  <ProductForm
    :class="!loading && 'disable-ske'"
    :value="initialData"
    :isShowing="isShowing"

    :productWebsites="productWebsites"
    :product="product"

    @save="save"
  />
</template>

<script>

import ProductForm from "./ProductFields/Form.vue"

export default {
  components: {
    ProductForm,
  },
  props: {
    isShowing: Boolean,
    baseData: Object,
    websiteUid: String,
    productId: String,

    productWebsites: Array,
    product: Object,
  },
  data() {
    return {
      initialData: {},
      loading: true,
    }
  },
  created() {
    this.loadOverwritenProduct()
  },
  methods: {
    async save(form) {
      this.$handlePromise(async () => {
        await this.axios.put(`/api/websites/${this.websiteUid}/products/${this.productId}`, form)
        this.$store.dispatch('clearCacheSearch', "products")
        this.$store.dispatch('clearCacheSearch', "websites")
        await this.loadOverwritenProduct()
        this.$success("Product succesvol overschreven!")
      })
    },
    async loadOverwritenProduct() {
      this.loading = true

      let overwritten = {}
      let website = {}
      try {
        overwritten = (await this.axios.get(`/api/websites/${this.websiteUid}/products/${this.productId}`)).data
        website = (await this.axios.get(`/api/websites/${this.websiteUid}`)).data
      } catch (err) {}

      const data = {...this.baseData}
      Object.keys(data).forEach(key => {
        if (overwritten[key]) data[key] = overwritten[key]
      })
      data.price = !overwritten.price ? this.baseData.recommended_retail_price : overwritten.price
      if (website && website.properties.wholesale == true) {
        data.price = !overwritten.price ? this.baseData.wholesale_price : overwritten.price
      }

      this.initialData = data
      this.loading = false
    },
  },
  watch: {
    websiteUid() {
      this.loadOverwritenProduct()
    },
  },
}

</script>

